// extracted by mini-css-extract-plugin
export default {"textField":"MySelect_textField__p6vAy","formControl":"MySelect_formControl__8iiq2","clearBox":"MySelect_clearBox__MX764"};